import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderModel } from '../models/OrdersViewModel';
import Order from './order';

@Component({ 
    name: 'lister-component',
    components: { Order },
    template: '#lister-component'
})
export default class Lister extends Vue {
    @Prop({})
    orders: Fonmoney.Definitions.IPagedList<OrderModel>;

    @Prop({})
    pageIndex: number;

    @Prop({})
    itemsOnPage: number;
}